import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { ProSidebar, SidebarHeader, SidebarContent } from "react-pro-sidebar";
import "react-pro-sidebar/dist/css/styles.css";
import "../styles/Sidenavbar.scss";
import profileimg from "../images/admin-1.png";
import SalesBee from "../images/SalesBeeColor.svg";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { baseURL } from "./BaseUrl";
import { useEffect } from "react";

function Sidenavbar(props) {
  const [open, setOpen] = useState(false);
  const [subId, setSubId] = useState("");

  const menuCollapse = props.menuCollapse;

  const resPassData = JSON.parse(sessionStorage.getItem("usrlgndtls"));

  const [menuItems, setMenuItems] = useState([])
  const [submenuAtt, setSubmenuAtt] = useState([])
  const [submenuClm, setSubmenuClm] = useState([])
  const [submenuStg, setSubmenuStg] = useState([])

  useEffect(() => {
    let activities = [];
    let subActAtt = [];
    let subActClm = [];
    let subActStng = [];
    if (resPassData?.subscription?.modules.length != 0) {

      resPassData?.subscription?.modules.map((item) => {
        if (item.parentModuleName === null) {
          activities.push({ name: item.moduleName, subNames: [] })
        }
        else if (item.parentModuleName === "Attendance") {
          subActAtt.push({ name: item.moduleName })
        }
        else if (item.parentModuleName === "Claims") {
          subActClm.push({ name: item.moduleName })
        }
        else if (item.parentModuleName === "Settings") {
          subActStng.push({ name: item.moduleName })
        }
      })


    } else {
      activities.push({ name: "Dashboard", subNames: [] })
    }
    setMenuItems(activities)
    setSubmenuAtt(subActAtt)
    setSubmenuClm(subActClm)
    setSubmenuStg(subActStng)
  }, [])

  useEffect(() => {
    if (menuItems) {
      menuItems.map((activities) => {
        if (activities.name === "Attendance") {
          activities.subNames = submenuAtt
        }
        if (activities.name === "Claims") {
          activities.subNames = submenuClm
        }
        if (activities.name === "Settings") {
          activities.subNames = submenuStg
        }
      })
    }
  }, [menuItems, submenuAtt, submenuClm, submenuStg])


  const loggedInRole = resPassData?.roleId;

  // const GetImage = (img, defaultImg) => {
  //   return img != undefined &&
  //     img !== null &&
  //     img !== "" &&
  //     img !== "no_img.png"
  //     ? `${baseURL}/${img}`
  //     : defaultImg;
  // };
  // if (resPassData != null) {
  //   resPassData.profilePic = GetImage(resPassData?.profilePic, profileimg);
  // }


  let passedId = sessionStorage.getItem("userID");

  const subMenuOpen = (e) => {
    setSubId(e.target.id);
    setOpen(!open);
  };

  return (
    <div>
      <div id="header">
        <ProSidebar collapsed={menuCollapse} className="pro-side-bar">
          <SidebarHeader className="side_bar_header_main">
            <div className="logotext">
              <span className="logo profile-mini">
                {menuCollapse ? (
                  <div className="profile-image">
                    <img
                      src={
                        resPassData?.profilePic !== "" &&
                          resPassData?.profilePic !== null &&
                          resPassData?.profilePic !== "no_img.png"
                          ? `${baseURL}/${resPassData?.profilePic}`
                          : profileimg
                      }
                      alt="Profile-Img"
                    />
                  </div>
                ) : (
                  <Link className="travelize_logo" to="/dashboard">
                    <img
                      src={SalesBee}
                      alt="product-title-img"
                      className="salesbee-logo"
                    />
                  </Link>
                )}
              </span>
            </div>
          </SidebarHeader>

          {!menuCollapse ? (
            <div className="profile-image-sidebar-big">
              {/* <div className="profile-image">
                <img
                  className="sidbar logo-img"
                  // src={profileimg}
                  src={
                    resPassData?.profilePic !== "" &&
                      resPassData?.profilePic !== null &&
                      resPassData?.profilePic !== "no_img.png"
                      ? `${baseURL}/${resPassData?.profilePic}`
                      : profileimg
                  }
                  alt="Profile Image"
                />
              </div> */}
              {/* <div className="profile-data" style={{ maxWidth: "175px", paddingTop: "10px" }}>
                <div className="profile-data-name">{resPassData?.fullName}</div>
                <div className="profile-data-title">
                  {resPassData?.userRole?.roleName}
                </div>
              </div> */}
              <div className="profile-controls">
                {/* <Link
                  to="/settings/profile"
                  className="profile-control-left"
                  title="Profile"
                >
                  <span className="fa fa-info"></span>
                </Link> */}
                {/* <Link
                  className="profile-control-right"
                  to="/settings/accountsettings"
                  // onClick={() => window.open("http://www.gmail.com")}
                  title="Settings"
                >
                  <span className="fa fa-cogs"></span>
                </Link> */}
              </div>
            </div>
          ) : (
            ""
          )}
          <SidebarContent
            className="sidebar_content sidenavbar-scroll"
            id="sidenavAccordion"
          >
            {/* START NAV LINK ITEMS */}
            {!menuCollapse ? (
              <div>
                {menuItems && menuItems.map((menuItems, i) => (
                  <div className="expanded-nav-bar" key={i}>
                    {menuItems.name === "Dashboard" &&
                      <Link to="/dashboard">
                        <div
                          className={
                            window.location.hash === `#/dashboard`
                              ? "sidebar-item plain active"
                              : "sidebar-item plain"
                          }
                        >
                          <li>
                            <div className="nav-link-item d-flex">
                              <div className="fa-icon-div">
                                <span className="fa fa-desktop"></span>
                              </div>
                              {/* <span className="xn-text">DASHBOARD</span> */}
                              <span className="xn-text">Dashboard</span>
                              <i
                                className="bi-chevron-down toggle-btn"
                                style={{ visibility: "hidden" }}
                              ></i>
                            </div>
                          </li>
                        </div>
                      </Link>
                    }
                    {menuItems.name === "Users" &&
                      <Link to="/users">
                        <div
                          className={
                            window.location.hash === `#/users`
                              ? "sidebar-item plain active"
                              : "sidebar-item plain"
                          }
                        >
                          <li>
                            <div className="nav-link-item d-flex">
                              <div className="fa-icon-div">
                                <span className="fa fa-group"></span>
                              </div>
                              <span className="xn-text">Users</span>
                              <i
                                className="bi-chevron-down toggle-btn"
                                style={{ visibility: "hidden" }}
                              ></i>
                            </div>
                          </li>
                        </div>
                      </Link>
                    }
                    {/* <Link to="/tracker">
                  <div
                    className={
                      window.location.hash == `#/tracker` ||
                      window.location.hash == `#/trackbyuser/${passedId}`
                        ? "sidebar-item plain active"
                        : "sidebar-item plain"
                    }
                  >
                    <li>
                      <div className="nav-link-item d-flex">
                        <div className="fa-icon-div">
                          <span className="fa fa-thumb-tack"></span>
                        </div>
                        <span className="xn-text">TRACKER</span>
                        <i
                          className="bi-chevron-down toggle-btn"
                          style={{ visibility: "hidden" }}
                        ></i>
                      </div>
                    </li>
                  </div>
                </Link> */}
                    {(menuItems.name === "Attendance") &&
                      <div
                        className={
                          (subId === "attendance" && open) ||
                            window.location.hash === `#/attendance/monthly` ||
                            window.location.hash === `#/attendance/fullday`
                            ? "sidebar-item open"
                            : "sidebar-item"
                        }
                      >
                        <li
                          name="ATTENDANCE"
                          id="attendance"
                          onClick={(e) => subMenuOpen(e)}
                          className={
                            (subId === "attendance" && open) ||
                              window.location.hash === `#/attendance/monthly` ||
                              window.location.hash === `#/attendance/fullday`
                              ? "nav-link-item drop-down-item active"
                              : "nav-link-item drop-down-item drop-main"
                          }
                        >
                          <div className="sidebar-title" id="attendance">
                            <div className="fa-icon-div">
                              <span className="fa fa-calendar-check-o" />
                            </div>
                            <span
                              className="xn-text"
                              name="attendance"
                              id="attendance"
                            >
                              Attendance
                            </span>
                            <i
                              className="bi-chevron-down toggle-btn"
                              id="attendance"
                            />
                          </div>
                        </li>
                        {(subId === "attendance" && open) ||
                          window.location.hash === `#/attendance/monthly` ||
                          window.location.hash === `#/attendance/fullday` ? (
                          <>
                            {menuItems.subNames.map((subMenu) => (
                              <div>
                                {subMenu.name == "Monthly" &&
                                  <Link to="/attendance/monthly">
                                    <div
                                      className={
                                        window.location.hash === `#/attendance/monthly`
                                          ? `sidebar-content sub-active`
                                          : `sidebar-content`
                                      }
                                    >
                                      <div className="nav-link-item">
                                        <span className="bi bi-diamond-fill"></span>
                                        <span className="xn-text">Monthly</span>
                                      </div>
                                    </div>
                                  </Link>
                                }

                                {subMenu.name === "Fullday" &&
                                  <Link to="/attendance/fullday">
                                    <div
                                      className={
                                        window.location.hash === `#/attendance/fullday`
                                          ? `sidebar-content sub-active`
                                          : `sidebar-content`
                                      }
                                    >
                                      <div className="nav-link-item">
                                        <span className="bi bi-diamond-fill"></span>
                                        <span className="xn-text">Full Day</span>
                                      </div>
                                    </div>
                                  </Link>
                                }
                              </div>
                            ))
                            }
                          </>
                        ) : (
                          ""
                        )}
                      </div>
                    }
                    {menuItems.name === "Leaves" &&
                      <Link to="/leaves">
                        <div
                          className={
                            window.location.hash === `#/leaves`
                              ? "sidebar-item plain active"
                              : "sidebar-item plain"
                          }
                        >
                          <li>
                            <div className="nav-link-item d-flex">
                              <div className="fa-icon-div">
                                <span className="bi bi-ui-checks fa"></span>
                              </div>
                              <span className="xn-text">Leaves</span>
                              <i
                                className="bi-chevron-down toggle-btn"
                                style={{ visibility: "hidden" }}
                              ></i>
                            </div>
                          </li>
                        </div>
                      </Link>
                    }
                    {menuItems.name === "Meetings" &&
                      <Link to="/meetings">
                        <div
                          className={
                            window.location.hash === `#/meetings`
                              ? "sidebar-item plain active"
                              : "sidebar-item plain"
                          }
                        >
                          <li>
                            <div className="nav-link-item d-flex">
                              <div className="fa-icon-div">
                                <span className="fa fa-handshake-o"></span>
                              </div>
                              <span className="xn-text">Meetings</span>
                              <i
                                className="bi-chevron-down toggle-btn"
                                style={{ visibility: "hidden" }}
                              ></i>
                            </div>
                          </li>
                        </div>
                      </Link>
                    }
                    {menuItems.name === "Clients" &&

                      <Link to="/company">
                        <div
                          className={
                            window.location.hash === `#/company`
                              ? `sidebar-item plain active`
                              : `sidebar-item plain`
                          }
                        >
                          <li>
                            <div className="nav-link-item d-flex">
                              <div className="fa-icon-div">
                                <span className="fa fa-user-circle"></span>
                              </div>
                              <span className="xn-text">Company</span>
                              <i
                                className="bi-chevron-down toggle-btn"
                                style={{ visibility: "hidden" }}
                              />
                            </div>
                          </li>
                        </div>
                      </Link>
                    }
                    {menuItems.name === "Products" &&
                      <Link to="/products">
                        <div
                          className={
                            window.location.hash === `#/products`
                              ? `sidebar-item plain active`
                              : `sidebar-item plain`
                          }
                        >
                          <li>
                            <div className="nav-link-item d-flex">
                              <div className="fa-icon-div">
                                <span className="fa fa-cube"></span>
                              </div>
                              <span className="xn-text">Products</span>
                              <i
                                className="bi-chevron-down toggle-btn"
                                style={{ visibility: "hidden" }}
                              />
                            </div>
                          </li>
                        </div>
                      </Link>
                    }
                    {menuItems.name === "Spares" &&
                      <Link to="/spares">
                        <div
                          className={
                            window.location.hash === `#/spares`
                              ? `sidebar-item plain active`
                              : `sidebar-item plain`
                          }
                        >
                          <li>
                            <div className="nav-link-item d-flex">
                              <div className="fa-icon-div">
                                <span className="fa fa-cogs"></span>
                              </div>
                              <span className="xn-text">Spares</span>
                              <i
                                className="bi-chevron-down toggle-btn"
                                style={{ visibility: "hidden" }}
                              />
                            </div>
                          </li>
                        </div>
                      </Link>
                    }
                    {
                      menuItems.name === "Spares" &&
                      <Link to="/amc">
                        <div
                          className={
                            window.location.hash == `#/amc`
                              ? `sidebar-item plain active`
                              : `sidebar-item plain`
                          }
                        >
                          <li>
                            <div className="nav-link-item d-flex">
                              <div className="fa-icon-div">
                                <span className="fa fa-cogs"></span>
                              </div>
                              <span className="xn-text">AMC</span>
                              <i
                                className="bi-chevron-down toggle-btn"
                                style={{ visibility: "hidden" }}
                              />
                            </div>
                          </li>
                        </div>
                      </Link>
                    }
                    {menuItems.name === "Claims" &&
                      <div
                        className={
                          (subId === "claims" && open) ||
                            window.location.hash === `#/localclaim` ||
                            window.location.hash === `#/outstationclaim`
                            ? "sidebar-item open"
                            : "sidebar-item"
                        }
                      >
                        <li
                          name="CLAIMS"
                          className={
                            (subId === "claims" && open) ||
                              window.location.hash === `#/localclaim` ||
                              window.location.hash === `#/outstationclaim`
                              ? "nav-link-item active"
                              : "nav-link-item drop-main"
                          }
                          id="claims"
                          onClick={(e) => subMenuOpen(e)}
                        >
                          <div className="sidebar-title" id="claims">
                            <div className="fa-icon-div">
                              <span className="bi bi-currency-dollar fa" />
                            </div>
                            <span className="xn-text" name="CLAIMS" id="claims">
                              Claims
                            </span>
                            <i className="bi-chevron-down toggle-btn" id="claims" />
                          </div>
                        </li>
                        {(subId === "claims" && open) ||
                          window.location.hash === `#/localclaim` ||
                          window.location.hash === `#/outstationclaim` ? (
                          <>
                            {menuItems.subNames.map((subMenu) => (
                              <div>
                                {subMenu.name === "Localclaims" &&
                                  <Link to="/localclaim">
                                    <div
                                      className={
                                        window.location.hash === `#/localclaim`
                                          ? `sidebar-content sub-active`
                                          : `sidebar-content`
                                      }
                                    >
                                      <div className="nav-link-item">
                                        <span className="bi bi-diamond-fill"></span>
                                        {/* <span className="xn-text">MANAGER</span> */}
                                        <span className="xn-text">Local Claim</span>
                                      </div>
                                    </div>
                                  </Link>
                                }
                                {subMenu.name === "Outstationclaims" &&
                                  <Link to="/outstationclaim">
                                    <div
                                      className={
                                        window.location.hash === `#/outstationclaim`
                                          ? `sidebar-content sub-active`
                                          : `sidebar-content`
                                      }
                                    >
                                      <div className="nav-link-item">
                                        <span className="bi bi-diamond-fill"></span>
                                        {/* <span className="xn-text">ADMIN</span> */}
                                        <span className="xn-text">Outstation Claim</span>
                                      </div>
                                    </div>
                                  </Link>
                                }
                              </div>
                            ))}
                          </>
                        ) : (
                          ""
                        )}
                      </div>
                    }
                    {/* {menuItems.name === "Settings" &&
                      <div
                        className={
                          (subId === "settings" && open) ||
                            window.location.hash === `#/settings/schedule` ||
                            window.location.hash === `#/settings/department` ||
                            window.location.hash === `#/settings/designations` ||
                            window.location.hash === `#/settings/accountsettings` ||
                            window.location.hash === `#/settings/devicedetails` ||
                            window.location.hash === `#/settings/trackclients` ||
                            window.location.hash === `#/settings/meetingpurpose` ||
                            window.location.hash === `#/settings/basefare` ||
                            window.location.hash === `#/settings/profile` ||
                            window.location.hash === `#/settings/accountdetails`
                            ? "sidebar-item open"
                            : "sidebar-item"
                        }
                      >
                        <li
                          name="SETTINGS"
                          id="settings"
                          className={
                            (subId === "settings" && open) ||
                              window.location.hash === `#/settings/schedule` ||
                              window.location.hash === `#/settings/department` ||
                              window.location.hash === `#/settings/designations` ||
                              window.location.hash === `#/settings/accountsettings` ||
                              window.location.hash === `#/settings/devicedetails` ||
                              window.location.hash === `#/settings/trackclients` ||
                              window.location.hash === `#/settings/meetingpurpose` ||
                              window.location.hash === `#/settings/basefare` ||
                              window.location.hash === `#/settings/profile` ||
                              window.location.hash === `#/settings/accountdetails`
                              ? "nav-link-item active"
                              : "nav-link-item drop-main"
                          }
                          onClick={(e) => subMenuOpen(e)}
                        >
                          <div className="sidebar-title" id="settings">
                            <div className="fa-icon-div">
                              <span className="fa fa-cog" />
                            </div>
                            <span className="xn-text" name="settings" id="settings">
                              Settings
                            </span>
                            <i className="bi-chevron-down toggle-btn" id="settings" />
                          </div>
                        </li>
                        {(subId === "settings" && open) ||
                          window.location.hash === `#/settings/schedule` ||
                          window.location.hash === `#/settings/department` ||
                          window.location.hash === `#/settings/designations` ||
                          window.location.hash === `#/settings/accountsettings` ||
                          window.location.hash === `#/settings/devicedetails` ||
                          window.location.hash === `#/settings/trackclients` ||
                          window.location.hash === `#/settings/meetingpurpose` ||
                          window.location.hash === `#/settings/basefare` ||
                          window.location.hash === `#/settings/profile` ||
                          window.location.hash === `#/settings/accountdetails` ? (
                          <>
                            {menuItems.subNames.map((subMenu) => (
                              <div>
                                {subMenu.name === "Schedule" &&
                                  <Link to="/settings/schedule">
                                    <div
                                      className={
                                        window.location.hash === `#/settings/schedule`
                                          ? `sidebar-content sub-active`
                                          : `sidebar-content`
                                      }
                                    >
                                      <div className="nav-link-item">
                                        <span className="bi bi-diamond-fill"></span>
                                        <span className="xn-text">Schedule</span>
                                      </div>
                                    </div>
                                  </Link>
                                }


                                {subMenu.name === "Trackclients" &&
                                  <Link to="/settings/trackclients">
                                    <div
                                      className={
                                        window.location.hash === `#/settings/trackclients`
                                          ? `sidebar-content sub-active`
                                          : `sidebar-content`
                                      }
                                    >
                                      <div className="nav-link-item">
                                        <span className="bi bi-diamond-fill"></span>
                                        <span className="xn-text">Track Clients</span>
                                      </div>
                                    </div>
                                  </Link>
                                }
                                {subMenu.name === "Department" &&
                                  <Link to="/settings/department">
                                    <div
                                      className={
                                        window.location.hash === `#/settings/department`
                                          ? `sidebar-content sub-active`
                                          : `sidebar-content`
                                      }
                                    >
                                      <div className="nav-link-item">
                                        <span className="bi bi-diamond-fill"></span>
                                        <span className="xn-text">Department</span>
                                      </div>
                                    </div>
                                  </Link>
                                }
                                {subMenu.name === "Designation" &&
                                  <Link to="/settings/designations">
                                    <div
                                      className={
                                        window.location.hash === `#/settings/designations`
                                          ? `sidebar-content sub-active`
                                          : `sidebar-content`
                                      }
                                    >
                                      <div className="nav-link-item">
                                        <span className="bi bi-diamond-fill"></span>
                                        <span className="xn-text">Designation</span>
                                      </div>
                                    </div>
                                  </Link>
                                }
                                {subMenu.name === "Roles" &&
                                  <Link to="/settings/role">
                                    <div
                                      className={
                                        window.location.hash === `#/settings/role`
                                          ? `sidebar-content sub-active`
                                          : `sidebar-content`
                                      }
                                    >
                                      <div className="nav-link-item">
                                        <span className="bi bi-diamond-fill"></span>
                                        <span className="xn-text">Role</span>
                                      </div>
                                    </div>
                                  </Link>
                                }
                                {subMenu.name === "Meetingpurpose" &&
                                  <Link to="/settings/meetingpurpose">
                                    <div
                                      className={
                                        window.location.hash ===
                                          `#/settings/meetingpurpose`
                                          ? `sidebar-content sub-active`
                                          : `sidebar-content`
                                      }
                                    >
                                      <div className="nav-link-item">
                                        <span className="bi bi-diamond-fill"></span>
                                        <span className="xn-text">Meeting Purpose</span>
                                      </div>
                                    </div>
                                  </Link>
                                }
                                {subMenu.name === "Basefare" &&
                                  <Link to="/settings/basefare">
                                    <div
                                      className={
                                        window.location.hash === `#/settings/basefare`
                                          ? `sidebar-content sub-active`
                                          : `sidebar-content`
                                      }
                                    >
                                      <div className="nav-link-item">
                                        <span className="bi bi-diamond-fill"></span>
                                        <span className="xn-text">Basefare</span>
                                      </div>
                                    </div>
                                  </Link>
                                }
                                {subMenu.name === "Profile" &&
                                  <Link to="/settings/profile">
                                    <div
                                      className={
                                        window.location.hash === `#/settings/profile`
                                          ? `sidebar-content sub-active`
                                          : `sidebar-content`
                                      }
                                    >
                                      <div className="nav-link-item">
                                        <span className="bi bi-diamond-fill"></span>
                                        <span className="xn-text">Profile</span>
                                      </div>
                                    </div>
                                  </Link>
                                }
                                {subMenu.name === "AccountSettings" &&
                                  <Link to="/settings/accountsettings">
                                    <div
                                      className={
                                        window.location.hash ===
                                          `#/settings/accountsettings`
                                          ? `sidebar-content sub-active`
                                          : `sidebar-content`
                                      }
                                    >
                                      <div className="nav-link-item">
                                        <span className="bi bi-diamond-fill"></span>
                                        <span className="xn-text">
                                          Account Settings
                                        </span>
                                      </div>
                                    </div>
                                  </Link>
                                }
                                {subMenu.name === "Devicedetails" &&
                                  <Link to="/settings/devicedetails">
                                    <div
                                      className={
                                        window.location.hash ===
                                          `#/settings/devicedetails`
                                          ? `sidebar-content sub-active`
                                          : `sidebar-content`
                                      }
                                    >
                                      <div className="nav-link-item">
                                        <span className="bi bi-diamond-fill"></span>
                                        <span className="xn-text">Device Details</span>
                                      </div>
                                    </div>
                                  </Link>
                                }
                                {subMenu.name === "Accountdetails" &&
                                  <Link to="/settings/accountdetails">
                                    <div
                                      className={
                                        window.location.hash ===
                                          `#/settings/accountdetails`
                                          ? `sidebar-content sub-active`
                                          : `sidebar-content`
                                      }
                                    >
                                      <div className="nav-link-item">
                                        <span className="bi bi-diamond-fill"></span>
                                        <span className="xn-text">Account Details</span>
                                      </div>
                                    </div>
                                  </Link>
                                }
                              </div>
                            ))}
                          </>
                        ) : (
                          ""
                        )}
                      </div>
                    } */}
                  </div>
                ))}
              </div>
            ) : (
              //  COLLAPSED NAV BAR START
              <div className="collapsed-nav-bar">
                <OverlayTrigger
                  placement={"right"}
                  delay={{ show: 250, hide: 300 }}
                  overlay={
                    <Tooltip id={`tooltip-dashboard`}>Dashboard</Tooltip>
                  }
                >
                  <li id="#dashboard">
                    <NavLink to="/dashboard">
                      <span className="fa fa-desktop"></span>
                    </NavLink>
                  </li>
                </OverlayTrigger>

                <OverlayTrigger
                  placement={"right"}
                  delay={{ show: 250, hide: 300 }}
                  overlay={<Tooltip id={`tooltip-users`}>Users</Tooltip>}
                >
                  <li id="#users">
                    <NavLink to="/users">
                      <span className="fa fa-group"></span>
                    </NavLink>
                  </li>
                </OverlayTrigger>

                <OverlayTrigger
                  placement={"right"}
                  delay={{ show: 250, hide: 300 }}
                  overlay={
                    <Tooltip id={`tooltip-meetings`}>Attendance</Tooltip>
                  }
                >
                  <li id="attendance" className="xn-openable">
                    <NavLink to="/attendance/monthly">
                      <span className="fa fa-calendar-check-o"></span>
                    </NavLink>
                  </li>
                </OverlayTrigger>

                {/* <OverlayTrigger
                  placement={"right"}
                  delay={{ show: 250, hide: 300 }}
                  overlay={<Tooltip id={`tooltip-tracker`}>TRACKER</Tooltip>}
                >
                  <li id="#tracker">
                    <NavLink to="/tracker">
                      <span className="fa fa-thumb-tack"></span>
                    </NavLink>
                  </li>
                </OverlayTrigger> */}

                <OverlayTrigger
                  placement={"right"}
                  delay={{ show: 250, hide: 300 }}
                  overlay={<Tooltip id={`tooltip-meetings`}>Leaves</Tooltip>}
                >
                  <li id="leaves">
                    <NavLink to="/leaves">
                      <span className="bi bi-ui-checks fa"></span>
                    </NavLink>
                  </li>
                </OverlayTrigger>

                <OverlayTrigger
                  placement={"right"}
                  delay={{ show: 250, hide: 300 }}
                  overlay={<Tooltip id={`tooltip-meetings`}>Meetings</Tooltip>}
                >
                  <li id="meetings">
                    <NavLink to="/meetings">
                      <span className="fa fa-handshake-o"></span>
                    </NavLink>
                  </li>
                </OverlayTrigger>

                <OverlayTrigger
                  placement={"right"}
                  delay={{ show: 250, hide: 300 }}
                  overlay={<Tooltip id={`tooltip-meetings`}>Company</Tooltip>}
                >
                  <li id="claims" className="xn-openable">
                    <NavLink to="/company">
                      <span className="fa fa-user-circle"></span>
                    </NavLink>
                  </li>
                </OverlayTrigger>

                <OverlayTrigger
                  placement={"right"}
                  delay={{ show: 250, hide: 300 }}
                  overlay={<Tooltip id={`tooltip-meetings`}>Claim</Tooltip>}
                >
                  <li id="claims" className="xn-openable">
                    <NavLink to="/localclaim">
                      <span className="bi bi-currency-dollar fa"></span>
                    </NavLink>
                  </li>
                </OverlayTrigger>

                <OverlayTrigger
                  placement={"right"}
                  delay={{ show: 250, hide: 300 }}
                  overlay={<Tooltip id={`tooltip-meetings`}>Settings</Tooltip>}
                >
                  <li id="settings" className="xn-openable">
                    <NavLink to="/settings/profile">
                      <span className="fa fa-cogs"></span>
                    </NavLink>
                  </li>
                </OverlayTrigger>
              </div>
              //  COLLAPSED NAV BAR END
            )}
            {/* END NAV LINK ITEMS */}
          </SidebarContent>
        </ProSidebar>
      </div>
      <Link to={'/settings'}>
        <div className="setting-image">
          <img src="../images/Settings/Settings.png" />
        </div>
      </Link>
    </div>
  );
}

export default Sidenavbar;
